import React, { useRef, useState } from "react";
import { colors, fonts, mediaQueriesNumbers, useMediaQuery, frames, glyphs, css } from "../../Styles";
import { NewInputList, NewModal, MainContentPaddingTypes } from "..";
import { ButtonTypes, ListStyle_Types, NewInputListHandles } from "../../Definitions";
import { useTranslation } from "react-i18next";
import { useUser } from "../../Services"
import NewButton from "../BaseComponents/newButton";

interface loginProps {
  ifSuccess: () => void
  onClose: () => void
  onCreateUser: () => void
  onResetPassword: () => void
}

export default function LoginModal({ifSuccess, onClose, onCreateUser, onResetPassword}:loginProps) {
  const {t} = useTranslation()
  const { doLogin } = useUser()
  const [message, setMessage] = useState<string|undefined>(undefined)
  const inputRef=useRef<NewInputListHandles>(null)
  const mobile = useMediaQuery(`(max-width: ${mediaQueriesNumbers.mobileMax}px)`);  


  // Use "Enter" to submit
  onkeydown = (event) => {
    if (event.code === "Enter") {
      LoginAction()
    }
  }

  const LoginAction = () => {
    if (inputRef && inputRef.current) {
      if (inputRef.current.refs && inputRef.current.refs.current) {
        var Username = inputRef.current.refs.current[0].value
        var Password = inputRef.current.refs.current[1].value

        if(!Username) {
          inputRef.current.refs.current[0].setError()
          setMessage(t("loginFlow.login.missingUserName", {defaultValue: "user Name is missing"}))
        }
        else if (!Password) {
          inputRef.current.refs.current[1].setError()
          setMessage(t("loginFlow.login.missingPassword", {defaultValue: "password is missing"}))
        }
        else {
          doLogin(Username.toString(), Password.toString()).then (e => {
            if (e) { 
              ifSuccess() 
            } else {
              setMessage(t("loginFlow.login.couldNotLogin", {defaultValue: "failed to log in"}));
            }
          })
        }
        setTimeout(() => {
          setMessage(undefined);
        }, 2000);
      }
    }
  }

  return ( 
    <frames.DecorBg>   
      <NewModal
        modalState
        header={`${t("loginFlow.login.welcomeBack", {defaultValue: "welcome back"})}!`}
        predefinedButtons={{
          onClose: onClose
        }}
        overrides={{
          mainContentPadding: MainContentPaddingTypes.secondary,
          overlayColor: colors.blackPrimary+"99"
        }}
        mainContent={
          <div style={{ display: "flex", justifyContent: "center" }}>
            <NewInputList ref={inputRef}
              headers={[t("user.userName", {defaultValue: "user name"}), t("user.password", {defaultValue: "password"})]}
              startEnhancers={[glyphs.User({}), glyphs.Password({})]}
              placeholders={["", ""]}
              isRequired={[true, true, false]}
              listOverrides={{
                listGap: "10px",
                listStyle: ListStyle_Types.vertical
              }}
              valueOverrides={{
                valueTypes: ["text", "password"]
              }}
            />
          </div>
        }
        footerMessage={message}
        footerContent={<>
          {/* Login button */}
          <NewButton content={t("loginFlow.login.login", {defaultValue: "log in"})} onClick={LoginAction}
            buttonType={ButtonTypes.primaryButton}
          />
          {/* Create user button */}
          <div style={{display: "flex", flexDirection: "row", gap: mobile? "20px" : "40px", marginTop: "40px"}}>
            <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
              <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary, textAlign: "center", marginBottom: "5px" }}>{`${t("loginFlow.login.notRegisteredYet", {defaultValue: "not registered yet"})}?`}</p>
              <NewButton
                content={t("loginFlow.login.createNewuser", {defaultValue: "create new user"})} 
                onClick={() => {onCreateUser()}}
                buttonType={ButtonTypes.textButton}
                overrides={{
                  contentStyles: {...css.button_TextUnderline, whiteSpace: "nowrap"}
                }}
              />
            </div>
            {/* Reset password button */}
            <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
              <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary, textAlign: "center", marginBottom: "5px" }}>{`${t("loginFlow.login.forgotPassword", {defaultValue: "Forgot password?"})}?`}</p>
              <NewButton
                content={t("loginFlow.login.resetPassword", {defaultValue: "reset password"})} 
                onClick={() => {onResetPassword()}}
                buttonType={ButtonTypes.textButton}
                overrides={{
                  contentStyles: {...css.button_TextUnderline, whiteSpace: "nowrap"}
                }}
              />
            </div>
          </div>
        </> }
      />
    </frames.DecorBg> 
  );
}